// 📐 معادلات حساب المشروع (سعر اللوحة / سعر البيع / سعر المشروع) - منقولة
// حرفياً من ProjectCostCalculator.jsx حتى تستخدمها واجهة المدير (حساب
// المشروع) وواجهة الفاتورة (فاتورة مشروع) بنفس الأرقام بالضبط، بدون نسختين
// تتباعدان مع الوقت.

/* ======================================================
   بيانات قائمة الأسعار الستاندرد
====================================================== */
export const frameData = [
  ["30 × 40", 45000, 75000],
  ["40 × 60", 70000, 115000],
  ["50 × 70", 85000, 135000],
  ["60 × 80", 100000, 165000],
  ["70 × 100", 125000, 195000],
  ["80 × 120", 185000, 275000],
  ["120 × 180", 295000, 395000],
  ["160 × 240", 395000, 515000],
  ["30 × 30", 40000, 75000],
  ["40 × 40", 45000, 85000],
  ["50 × 50", 60000, 100000],
  ["60 × 60", 65000, 115000],
  ["70 × 70", 95000, 150000],
  ["80 × 80", 100000, 165000],
  ["90 × 90", 115000, 185000],
  ["100 × 100", 135000, 215000],
  ["110 × 110", 175000, 265000],
  ["120 × 120", 185000, 275000],
  ["130 × 130", 215000, 315000],
];

export const kasData = [
  ["30 × 40", 65000, 95000],
  ["40 × 60", 75000, 115000],
  ["50 × 70", 105000, 165000],
  ["60 × 80", 140000, 205000],
  ["70 × 100", 175000, 245000],
  ["80 × 120", 245000, 325000],
  ["120 × 180", 385000, 495000],
  ["160 × 240", 495000, 615000],
  ["30 × 30", 45000, 75000],
  ["40 × 40", 60000, 95000],
  ["50 × 50", 75000, 115000],
  ["60 × 60", 95000, 135000],
  ["70 × 70", 125000, 175000],
  ["80 × 80", 150000, 215000],
  ["90 × 90", 165000, 235000],
  ["100 × 100", 195000, 265000],
  ["110 × 110", 235000, 315000],
  ["120 × 120", 265000, 345000],
  ["130 × 130", 285000, 375000],
];

export const DRAWING_TYPE_TEXT = { origin: "اورجن", edition: "ادشن" };
export const BOARD_TYPE_TEXT = {
  print_only: "خشب داخلي فقط",
  print_ail: "إطار أيل + داخلي",
  print_kas: "إطار كاس",
};

// customValue: معامل "ادخل القيمة" (سعر المشروع = سعر البيع × القيمة).
// ديفولت المدير 1.2 - فاتورة المشروع من الموظفة تمرّر 1 حتى يكون سعر
// المشروع = سعر البيع اللي كتبته.
export const createProjectItem = (index = 1, customValue = 1.2) => ({
  name: index,
  lengthCm: "",
  widthCm: "",
  drawingType: "origin",
  boardType: "print_ail",
  qty: 1,
  customValue,
  manualBoardPrice: "",
  manualSalePrice: "",
});

export const toNumber = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

const ceilToStep = (value, step) => Math.ceil(value / step) * step;

/* ======================================================
   سعر اللوحة من معادلة حساب كلفة اللوحة (0 إذا الطول/العرض فارغات)
====================================================== */
export const calcBoardPrice = (it) => {
  const L = toNumber(it.lengthCm);
  const W = toNumber(it.widthCm);

  if (L <= 0 || W <= 0) {
    return 0;
  }

  const printCost =
    ceilToStep((L / 100 + 0.05) * (W / 100 + 0.05), 0.2) * 25000;

  const baseDim = Math.ceil((L / 100 + W / 100) * 2 + 0.5);

  const innerWood = baseDim * 2000;
  const ail = baseDim * 5500;
  const kas = baseDim * 7500;

  if (it.boardType === "print_only") {
    return printCost + innerWood;
  }

  if (it.boardType === "print_ail") {
    return printCost + innerWood + ail;
  }

  if (it.boardType === "print_kas") {
    return printCost + innerWood + kas;
  }

  return printCost + innerWood;
};

/* ======================================================
   سعر البيع من اللستة فقط إذا القياس ستاندرد
====================================================== */
export const getStandardSalePrice = (it) => {
  const L = toNumber(it.lengthCm);
  const W = toNumber(it.widthCm);

  if (L <= 0 || W <= 0) return null;

  let dataSource = [];

  if (it.boardType === "print_ail") {
    dataSource = frameData;
  } else if (it.boardType === "print_kas") {
    dataSource = kasData;
  } else {
    return null;
  }

  const match = dataSource.find(([size]) => {
    const [sw, sh] = size.replace(/\s/g, "").split("×").map(Number);
    return (sw === L && sh === W) || (sw === W && sh === L);
  });

  if (!match) return null;

  return it.drawingType === "edition" ? match[2] : match[1];
};

export const calcSalePrice = (it, boardPrice) => {
  const L = toNumber(it.lengthCm);
  const W = toNumber(it.widthCm);

  if (L <= 0 || W <= 0) {
    return 0;
  }

  const standardSalePrice = getStandardSalePrice(it);

  if (standardSalePrice !== null) {
    return standardSalePrice;
  }

  if (it.boardType === "print_only") {
    if (it.drawingType === "edition") {
      return (boardPrice + 50000) * 2.25;
    }

    return boardPrice * 2.5;
  }

  if (it.boardType === "print_ail") {
    if (it.drawingType === "edition") {
      return (boardPrice + 50000) * 2.25;
    }

    return boardPrice * 2.5;
  }

  if (it.boardType === "print_kas") {
    if (it.drawingType === "edition") {
      return (boardPrice + 50000) * 2.25;
    }

    return boardPrice * 2.5;
  }

  return boardPrice * 2.5;
};

// نفس useMemo "results" بـProjectCostCalculator.jsx حرفياً
export const computeProjectResults = (items) => {
  const rows = (items || []).map((it, idx) => {
    const autoBoardPrice = calcBoardPrice(it);

    const boardPrice =
      it.manualBoardPrice !== "" && it.manualBoardPrice !== undefined
        ? toNumber(it.manualBoardPrice)
        : autoBoardPrice;

    const autoSalePrice = calcSalePrice(it, boardPrice);

    const salePrice =
      it.manualSalePrice !== "" && it.manualSalePrice !== undefined
        ? toNumber(it.manualSalePrice)
        : autoSalePrice;

    const qty = toNumber(it.qty);
    const customValue = toNumber(it.customValue);

    const boardTotal = boardPrice * qty;
    const saleTotal = salePrice * qty;

    const projectPrice = salePrice * customValue;
    const projectTotal = projectPrice * qty;

    return {
      ...it,
      index: idx + 1,
      name: it.name || idx + 1,
      boardPrice,
      boardTotal,
      salePrice,
      saleTotal,
      projectPrice,
      projectTotal,
    };
  });

  const grandTotal = rows.reduce((sum, r) => sum + r.projectTotal, 0);

  return { rows, grandTotal };
};

// 🧾 يحوّل صفوف المشروع (الطول/العرض/نوع اللوحة/نوع الإطار...) إلى شكل
// بنود الفاتورة (panelType/frameOption/frameType/sizeKey...) - الحقول
// التصميمية غير الموجودة أصلاً بحساب المشروع (لون الإطار، الصور) تُترك
// فارغة، بينما القياسات والكمية والسعر النهائي (سعر المشروع) تُنقَل حرفياً
// حتى يطابق مجموع الفاتورة مجموع المشروع تماماً.
export const buildInvoiceItemsFromProjectRows = (rows) =>
  rows.map((r) => {
    const length = toNumber(r.lengthCm);
    const width = toNumber(r.widthCm);

    return {
      manualPrice: true,
      panelName: `بند ${r.index}`,
      panelType: r.drawingType === "edition" ? "إدشن" : "أوريجن",
      panelShape:
        length > 0 && width > 0 && length === width
          ? "لوحة مربعة"
          : "لوحة مستطيلة أفقية",
      frameOption:
        r.boardType === "print_only" ? "إطار داخلي فقط" : "إطار كامل",
      frameType:
        r.boardType === "print_ail"
          ? "L"
          : r.boardType === "print_kas"
          ? "Kas"
          : "",
      customFrameType: "",
      sizeSource: "custom",
      sizeKey: width > 0 && length > 0 ? `${width}x${length}` : "",
      customHeight: r.lengthCm || "",
      customWidth: r.widthCm || "",
      frameColor: "",
      customFrameColor: "",
      quantity: toNumber(r.qty) || 1,
      pricePerPanel: Math.round(r.projectPrice || 0),
      total: Math.round(r.projectTotal || 0),
      // 📷 صور البند (فاتورة المشروع ترفعها لكل سطر، نفس شكل panelImages
      // بالفاتورة العادية) - مشروع حساب المدير بدون صور أصلاً
      panelImages: Array.isArray(r.panelImages) ? r.panelImages : [],
    };
  });

// 🏷️ ليبل فاتورة المشروع حسب منشئها: "مشروع من المدير" أو "مشروع بنين"
// (أو اسم أي موظفة أرسلته من حساب المشروع)
const PROJECT_CREATOR_NAMES = {
  "Baneen@123": "بنين",
  "rand@123": "رند",
  "maryam@123": "مريم",
  "farah@123": "فرح",
  "maysa@123": "مياسة",
};

export const isProjectInvoiceSource = (invoiceSource) =>
  invoiceSource === "projectCost" || invoiceSource === "projectInvoice";

export const getProjectInvoiceLabel = (createdBy) => {
  if (createdBy === "admin") return "🏗️ مشروع من المدير";
  const name = PROJECT_CREATOR_NAMES[createdBy] || createdBy;
  return name ? `🏗️ مشروع ${name}` : "🏗️ مشروع";
};
